/* import __COLOCATED_TEMPLATE__ from './company-profile-cost-codes-section.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

const CLASS_NAME = 'SH-c-company-profile-cost-codes-section';

class CostCodesSection extends Component {
  @tracked sectionShown = this.args.sectionShown;
  @tracked isAddingCode = false;

  get className() {
    return CLASS_NAME;
  }

  get dropdownDisabled() {
    return !this.args.codes.length;
  }

  @action
  toggleSection() {
    this.sectionShown = !this.sectionShown;
  }

  @action
  addCodeClicked() {
    this.isAddingCode = true;
  }

  @action
  cancelEditCode() {
    this.isAddingCode = false;
  }
}

export default CostCodesSection;
